"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.curry = exports.orderToNumber = exports.compare = exports.Order = exports.always = exports.identity = void 0;
/** The identity function, returns the value it was given */
const identity = (x) => x;
exports.identity = identity;
/** Returns a function that always returns the same value. Also known as `const` in other languages */
const always = (x) => () => x;
exports.always = always;
var Order;
(function (Order) {
    Order["LT"] = "LT";
    Order["EQ"] = "EQ";
    Order["GT"] = "GT";
})(Order = exports.Order || (exports.Order = {}));
/** Compares two values using the default "<" and ">" operators */
const compare = (x, y) => {
    if (x > y) {
        return Order.GT;
    }
    else if (x < y) {
        return Order.LT;
    }
    else {
        return Order.EQ;
    }
};
exports.compare = compare;
/** Maps the Order enum to the values expected by the standard ECMAScript library when doing comparison (Array.prototype.sort, for example) */
const orderToNumber = (order) => {
    switch (order) {
        case Order.LT:
            return -1;
        case Order.EQ:
            return 0;
        case Order.GT:
            return 1;
    }
};
exports.orderToNumber = orderToNumber;
/** Takes a function that receives multiple arguments and returns a "curried" version of that function that can take any number of those arguments and if they are less than needed a new function that takes the rest of them will be returned */
const curry = (fn) => function currify(...args) {
    return args.length >= fn.length
        ? fn.apply(undefined, args)
        : currify.bind(undefined, ...args);
};
exports.curry = curry;
